module.exports = __webpack_public_path__ + "static/media/13_360.a9b61331.jpeg";